import { render, staticRenderFns } from "./LeaveGroup.vue?vue&type=template&id=6a616f1a&scoped=true&"
import script from "./LeaveGroup.vue?vue&type=script&lang=js&"
export * from "./LeaveGroup.vue?vue&type=script&lang=js&"
import style0 from "./LeaveGroup.vue?vue&type=style&index=0&id=6a616f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a616f1a",
  null
  
)

export default component.exports